import { render, staticRenderFns } from "./lectureDetail.vue?vue&type=template&id=b49a653e&scoped=true&"
import script from "./lectureDetail.vue?vue&type=script&lang=js&"
export * from "./lectureDetail.vue?vue&type=script&lang=js&"
import style0 from "./lectureDetail.vue?vue&type=style&index=0&id=b49a653e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49a653e",
  null
  
)

export default component.exports